<template>
  <div id="top">
    <!-- <v-card-title class="color-services">Comments</v-card-title> -->

    <v-row class="pa-0" justify="center">
      <v-btn
        v-if="!isCheckResultClicked && showResultButton"
        color="#5271FF"
        dark
        width="250"
        @click="
          () => {
            isCheckResultClicked = true;
            scrollToSection();
            getComments();
          }
        "
        :loading="loading"
      >
        View Report
      </v-btn>
    </v-row>

    <!-- <v-row justify="center" align="center" v-if="loading" style="height:20vh">
      <v-progress-circular
        :size="70"
        color="#5c648b"
        indeterminate
      ></v-progress-circular>
    </v-row> -->

    <span id="comment-heading" v-if="isCheckResultClicked || !showResultButton">
      {{ title ? title : "Comments" }}
    </span>

    <v-row v-if="isCheckResultClicked && commentList.length < 1">
      <v-col cols="12" align="center">
        <v-img :src="calculatingResult" max-width="260" />
      </v-col>
      <v-col cols="12" align="center">
        <span class="try-again">
          <!-- We're calculating your results Please Wait or Try again later -->
          Please ensure you have submitted the form above. If submitted, please
          try again in a minute.
        </span>
      </v-col>
      <v-col cols="12" align="center">
        <v-btn
          color="#5271FF"
          dark
          width="250"
          @click="getComments"
          :loading="loading"
        >
          Try again
        </v-btn>
      </v-col>
    </v-row>

    <!-- <v-divider
      v-if="commentList.length > 0"
      class="my-4"
      style="border-color: #707070 !important; max-width: 144px"
    /> -->

    <!-- <v-card-text class="pa-0">
      <v-card class="mt-4" flat>
        <v-form ref="commentForm" lazy-validation>
          <v-row align="center" justify="center">
            <v-col>
              <VueEditor
                :apiKey="keys.tinykey"
                placeholder="Enter Comment here"
                v-model="comment"
                :init="editorInit"
              ></VueEditor>
            </v-col>
            <v-col cols="12" align="end">
              <v-btn
                dark
                small
                color="#5271FF"
                class="ps-12 pe-12"
                @click="validateAndSubmit"
                :loading="addCommentLoading"
              >
                <span>Send</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card> -->

    <v-card
      class="mt-4 ps-2"
      flat
      color="#5271FF1A"
      v-for="item in commentList"
      :key="item.id"
      style="border: 0.800000011920929px solid #5271FF;"
    >
      <v-row class="ma-0 pt-3">
        <v-avatar color="#41487A" size="34">
          <span class="initials">
            {{ getInitials(item.user_details.name) }}
          </span>
        </v-avatar>
        <v-col class="pa-2 pb-0">
          <v-row>
            <v-col cols="6" class="pa-0 ps-1">
              <h6 class="user-name ms-2">{{ item.user_details.name }}</h6>
            </v-col>
            <v-spacer />
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span class="time" v-on="on" style="cursor: pointer;">
                  {{ getFormatDate(item.created, false) }}
                </span>
              </template>
              <span>{{ getFormatDate(item.created, true) }}</span>
            </v-tooltip>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mt-n3"
                  icon
                  v-on="on"
                  :disabled="!item.is_editable"
                >
                  <v-icon color="#5c648b">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  @click="openEditComment(item)"
                  v-if="item.is_editable"
                >
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>

                <v-list-item
                  @click="deleteComment(item)"
                  v-if="item.is_editable"
                >
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
          <v-col v-if="item.edit" class="ps-0">
            <VueEditor
              :apiKey="keys.tinykey"
              placeholder="Enter Comment here"
              v-model="item.newcomment"
              :init="editorInit"
            ></VueEditor>
            <v-row class="ma-0 mt-2" justify="end">
              <v-btn
                small
                outlined
                color="indigo accent-3"
                @click="discardEditComment(item)"
              >
                <span>Discard Changes</span>
              </v-btn>
              <v-btn
                class="ms-2"
                dark
                small
                color="indigo accent-3"
                @click="editComment(item)"
                :loading="editLoading"
              >
                <span>Save Changes</span>
              </v-btn>
            </v-row>
          </v-col>
          <div v-else>
            <div
              class="pa-0 mt-2"
              v-html="item.comment"
              style="font-size: 1.125rem;font-weight: 300;letter-spacing: 0;line-height: 19px;"
            ></div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!-- <v-card class="mt-4" flat>
        <v-form ref="commentForm" lazy-validation>
          <v-row align="center" justify="center">
            <v-col>
              <VueEditor
                :apiKey="keys.tinykey"
                placeholder="Enter Comment here"
                v-model="comment"
                :init="editorInit"
              ></VueEditor>
            </v-col>
            <v-col cols="12" align="end">
              <v-btn
                dark
                large
                color="#5271FF"
                class="ps-12 pe-12"
                @click="validateAndSubmit"
                :loading="addCommentLoading"
              >
                <span>Send</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card> -->
    <!-- </v-card-text> -->
  </div>
</template>

<script>
  // import { quillEditor } from "vue-quill-editor";
  // import Editor from "@tinymce/tinymce-vue";
  var VueEditor = require("@tinymce/tinymce-vue").default;

  import Axios from "../../../api/BaseAxios";
  import RULES from "../../../common/fieldRules";
  import Keys from "../../../constants/keys";

  import AmplitudeHelper from "../../../amplitude";

  export default {
    name: "Comments",
    props: [
      "comments",
      "id",
      "addUrl",
      "editUrl",
      "deleteUrl",
      "getUrl",
      "title",
      "type",
      "showResultButton",
    ],
    components: {
      VueEditor,
    },
    data() {
      return {
        keys: Keys,
        rules: RULES,
        commentList: [],
        editorOption: {
          placeholder: "Add Comment or Upload Image",
          modules: {
            toolbar: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              [],
              ["link", "image"],

              [], // custom button values
              [{ list: "ordered" }, { list: "bullet" }],

              [{ indent: "-1" }, { indent: "+1" }], // outdent/indent

              [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ],
          },
        },
        editorInit: {
          selector: "textarea",
          height: 300,
          menubar: false,
          elementpath: false,
          icons: "material",
          plugins: [
            "print preview paste importcss searchreplace autolink directionality code visualblocks visualchars fullscreen image link media template table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help quickbars emoticons",
          ],
          toolbar:
            "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor | emoticons |  preview print | quickimage link",
          quickbars_insert_toolbar: false,
          quickbars_selection_toolbar: "bold italic | formatselect | quicklink",
          mobile: {
            toolbar_mode: "floating",
          },
        },
        comment: null,
        loading: false,
        editLoading: false,
        addCommentLoading: false,
        addComment: false,
        computedComments: [],
        calculatingResult: require("@/assets/parent/AssesmentResultEmpty.svg"),
        isCheckResultClicked: false,
      };
    },
    methods: {
      scrollToSection: function() {
        // var container = this.$el.querySelector(".report-section")[0];
        // console.log(container);
        // setTimeout(() => {  console.log("World!"); }, 2000);
        // container.scrollIntoView();
        // let elmnt = document.getElementById("top");
        // console.log(elmnt);
        // elmnt.scrollIntoView(false);
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
      },
      openEditComment(comment) {
        this.commentList.forEach((element) => {
          if (element == comment) {
            element.edit = true;
            element.newcomment = element.comment;
          }
        });
        this.$forceUpdate();
      },
      discardEditComment(comment) {
        this.commentList.forEach((element) => {
          if (element == comment) {
            element.edit = false;
          }
        });
        this.$forceUpdate();
      },
      editComment(comment) {
        var self = this;

        console.log(comment.comment);

        if (comment.comment != "") {
          this.editLoading = true;
          const successHandler = (res) => {
            console.log(res);
            // self.getGoalData();
            self.editLoading = false;
            comment.edit = false;
            comment.comment = comment.newcomment;
            this.$forceUpdate();
          };

          const failureHandler = (res) => {
            console.log(res);
            self.editLoading = false;
            comment.edit = false;
            this.$forceUpdate();
          };

          let requestParams = {};

          requestParams[Keys.ID] = comment.id;
          requestParams[Keys.COMMENT] = comment.newcomment;

          AmplitudeHelper.registerEvent(
            "Edit comment - " + this.type,
            requestParams
          );

          Axios.request_PATCH(
            this.editUrl,
            requestParams,
            {},
            successHandler,
            failureHandler,
            false
          );
        }
      },
      deleteComment(comment) {
        var self = this;

        console.log(comment.comment);
        AmplitudeHelper.registerEvent("Delete comment - " + this.type, comment);

        const successHandler = (res) => {
          // self.getGoalData();
          console.log(res);
          self.commentList.splice(this.commentList.indexOf(comment), 1);
          self.$forceUpdate();
        };

        const failureHandler = (res) => {
          console.log(res);
          self.$forceUpdate();
        };

        let requestParams = {};

        requestParams[Keys.ID] = comment.id;

        Axios.request_DELETE(
          this.deleteUrl,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      },
      getInitials(name) {
        var matches = name.match(/\b(\w)/g);
        return matches.join("").slice(0, 2);
      },
      getFormatDate(date, is_timestamp) {
        date = new Date(date);

        // let now = new Date();

        if (is_timestamp) {
          return date;
        } else {
          var monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];

          var minutes =
            date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes();
          var hour =
            date.getHours() < 10 ? "0" + date.getHours() : date.getHours();

          date =
            date.getDate() +
            " " +
            monthNames[date.getMonth()] +
            " " +
            date.getFullYear();

          return date + ", " + hour + ":" + minutes;
        }
      },
      validateAndSubmit() {
        var self = this;

        if (this.$refs.commentForm.validate() && this.comment) {
          this.addCommentLoading = true;
          const successHandler = (res) => {
            // self.getGoalData();
            self.addComment = false;
            self.addCommentLoading = false;
            self.comment = "";
            self.$refs.commentForm.reset();
            // self.commentList.push(res.data.data);
            self.commentList = [res.data.data].concat(self.commentList);
          };

          const failureHandler = (res) => {
            console.log(res);
            self.addCommentLoading = false;
          };

          let requestParams = {};

          requestParams[Keys.ID] = this.id;
          requestParams[Keys.COMMENT] = this.comment;

          AmplitudeHelper.registerEvent(
            "Add comment - " + this.type,
            requestParams
          );

          Axios.request_POST(
            this.addUrl,
            requestParams,
            {},
            successHandler,
            failureHandler,
            false
          );
        }
      },
      getComments() {
        var self = this;

        this.loading = true;
        const successHandler = (res) => {
          self.loading = false;
          self.commentList = res.data.data;
          self.commentList.forEach((element) => {
            element.edit = false;
          });
        };

        const failureHandler = (res) => {
          console.log(res);
          self.loading = false;
        };

        let requestParams = {};
        requestParams[Keys.ID] = this.id;
        requestParams[Keys.ORDER_BY_CREATED] = false;

        Axios.request_GET(
          this.getUrl,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      },
    },
    watch: {},
    computed: {
      // computedComments() {
      //   var list = new Array();
      //   this.commentList.forEach(element => {
      //     element.edit = false;
      //     list.push(element);
      //   });
      //   return list;
      // }
    },
    created() {
      // console.log(this.commentList == null);
      if (this.comments == null) {
        this.getComments();
      } else {
        this.comments.forEach((element) => {
          element.edit = false;
        });
        this.commentList = this.comments;
      }
    },
  };
</script>

<style scoped>
  #comment-heading {
    color: #5468ff;
    font-size: 18px;
  }
  .time {
    letter-spacing: 0px;
    font-weight: normal;
    font-size: 9px;
    line-height: 11px;
    color: #1d1d1d;
  }
  .user-name {
    letter-spacing: 0px;
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    color: #1d1d1d;
  }
  .initials {
    letter-spacing: 0px;
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    color: #ffffff;
  }
  .try-again {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    /* identical to box height */

    letter-spacing: 0.01em;

    color: rgba(51, 51, 51, 0.7);
  }
</style>
